export class Tile {
  x: number;
  y: number;
  z: number;

  constructor(x: number, y: number, z: number) {
    this.x = x;
    this.y = y;
    this.z = z;
  }

  static fromCoordinates(lat: number, lon: number, zoom: number = 10): Tile {
    // Validate and clamp latitude
    if (typeof lat !== 'number' || isNaN(lat)) {
      throw new Error('Latitude must be a valid number.');
    }
    if (typeof lon !== 'number' || isNaN(lon)) {
      throw new Error('Longitude must be a valid number.');
    }

    lat = Math.max(Math.min(lat, 85.05112878), -85.05112878);
    lon = ((lon + 180) % 360) - 180; // Wrap longitude within [-180, 180]

    const latRad = (lat * Math.PI) / 180;
    const n = Math.pow(2, zoom);

    const x = Math.floor(((lon + 180) / 360) * n);
    const y = Math.floor(
      ((1 -
          Math.log(Math.tan(latRad) + 1 / Math.cos(latRad)) / Math.PI) /
        2) *
      n
    );

    if (isNaN(x) || isNaN(y)) {
      throw new Error('Calculated tile coordinates are invalid.');
    }

    return new Tile(x, y, zoom);
  }
}
